import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { Amenity } from "@/types/Amenity";

interface AmenityFilterSelectProps {
  availableAmenities: Amenity[];
  selectedAmenities: Amenity[];
  onSelectionChange: (amenities: Amenity[]) => void;
  idPrefix?: string;
}

export const AmenityFilterSelect = ({
  availableAmenities,
  selectedAmenities,
  onSelectionChange,
  idPrefix = "amenity-filter",
}: AmenityFilterSelectProps) => {
  return (
    <div className="flex flex-col gap-1 max-h-[400px] overflow-y-auto">
      <div className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 rounded cursor-pointer">
        <Checkbox
          id={`${idPrefix}-all-amenities-checkbox`}
          checked={selectedAmenities.length === availableAmenities.length}
          onCheckedChange={(checked) => {
            if (checked) {
              onSelectionChange(availableAmenities);
            } else {
              onSelectionChange([]);
            }
          }}
        />
        <Label htmlFor={`${idPrefix}-all-amenities-checkbox`} className="flex-1 cursor-pointer font-semibold">
          All amenities
        </Label>
      </div>
      <div className="border-t border-gray-200 dark:border-gray-700 my-1" />
      {availableAmenities.map((amenity) => (
        <div
          key={amenity.id}
          className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 rounded cursor-pointer"
        >
          <Checkbox
            id={`${idPrefix}-amenity-${amenity.id}`}
            checked={selectedAmenities.some((a) => a.id === amenity.id)}
            onCheckedChange={(checked) => {
              if (checked) {
                onSelectionChange([...selectedAmenities, amenity]);
              } else {
                onSelectionChange(selectedAmenities.filter((a) => a.id !== amenity.id));
              }
            }}
          />
          <Label htmlFor={`${idPrefix}-amenity-${amenity.id}`} className="flex-1 cursor-pointer">
            {amenity.name}
          </Label>
        </div>
      ))}
    </div>
  );
};
